import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { useAuthStore } from '@/core/auth/auth-store';
import { loadRuntimeConfig } from '@/core/config/runtime-config.loader';

import { App } from './app/App';
import './styles.scss';

try {
    await loadRuntimeConfig();
    await useAuthStore.getState().init();

    const container = document.getElementById('root');
    if (!container) {
        throw new Error('Root container #root not found in index.html');
    }
    createRoot(container).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
} catch (err) {
    console.error('Failed to bootstrap application:', err);
}
